// extracted by mini-css-extract-plugin
export default {"form":"styles_form__o+IKe","labelContainer":"styles_labelContainer__hKJm6"};